import {Component, OnInit} from '@angular/core';
import {ActivatedRoute} from "@angular/router";
import {MatButton} from "@angular/material/button";
import {MatCard, MatCardContent} from "@angular/material/card";
import {MatFormField, MatLabel} from "@angular/material/form-field";
import {MatIcon} from "@angular/material/icon";
import {MatInput} from "@angular/material/input";
import {MatProgressSpinner} from "@angular/material/progress-spinner";
import {FormControl, FormGroup, ReactiveFormsModule, Validators} from "@angular/forms";
import {ApiService} from "../api.service";
import {NgSwitch, NgSwitchCase, NgSwitchDefault} from "@angular/common";

@Component({
  selector: 'app-register',
  imports: [
    MatButton,
    MatCard,
    MatCardContent,
    MatFormField,
    MatIcon,
    MatInput,
    MatLabel,
    MatProgressSpinner,
    ReactiveFormsModule,
    NgSwitch,
    NgSwitchCase,
    NgSwitchDefault
  ],
  templateUrl: './register.component.html',
  styleUrl: './register.component.css'
})
export class RegisterComponent implements OnInit {
  public id: any;
  public data: any;
  public email: any;
  public disableInputs: boolean = false;
  public loading: boolean = false;
  public errorMsg: any;

  constructor(private route: ActivatedRoute, public api: ApiService) {
  }

  ngOnInit() {
    this.id = this.route.snapshot.paramMap.get('id');
    if (this.route.snapshot.paramMap.get('data')) this.data = this.route.snapshot.paramMap.get('data');
    console.log(this.data);
  }

  emailForm = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
    submit: new FormControl()
  });

  async sendMail() {
    this.email = this.emailForm.get('email')?.value;
    this.emailForm.get('email')?.disable();
    this.emailForm.get('submit')?.disable();
    this.disableInputs = true;
    this.loading = true;
    // setTimeout(() => {this.loading = false;}, 5000);
    const error = await this.api.register(this.email, this.id, this.data);
    this.loading = false;
    if (error) {
      this.errorMsg = error;
      setTimeout(() => {
        this.emailForm.get('email')?.enable();
        this.emailForm.get('submit')?.enable();
        this.disableInputs = false;
      }, 1000);
    }
    else this.errorMsg = '';
  }

  ngAfterContentInit() {
    if (!this.api.isLogged)
      (document.querySelector('body') as HTMLElement).style.backgroundImage = 'linear-gradient(35deg, #fe3620 0%, #ff7c00 30%, #ff7c00 70%, #fe3620 90%)';
  }
}
